import { Route, Routes } from 'react-router-dom'

import { AdminLayout } from '../AdminLayout'
import { AdminGate } from '../session'
import { AdminDrinksPage } from './DrinksPage'
import { AdminFinancePage } from './FinancePage'
import { AdminEventPage } from './EventPage'
import { AdminFoodPage } from './FoodPage'
import { AdminClosingPage } from './ClosingPage'
import { AdminCompetitionPage } from './CompetitionPage'
import { AdminContentPage } from './ContentPage'
import { AdminMessagesPage } from './MessagesPage'
import { AdminOrdersPage } from './OrdersPage'
import { AdminReservationsPage } from './ReservationsPage'
import { AdminPlacementPage } from './PlacementPage'
import { AdminAccountPage } from './AccountPage'
import { AdminAuditPage } from './AuditPage'
import { AdminAudiencePage } from './AudiencePage'
import { AdminNotificationsPage } from './NotificationsPage'
import { AdminDocumentationPage } from './DocumentationPage'
import { AdminFeedbackPage } from './FeedbackPage'
import { AdminForecastPage } from './ForecastPage'
import { AdminGdprPage } from './GdprPage'
import { AdminStockPage } from './StockPage'
import { AdminServicePage } from './ServicePage'
import { AdminSettingsPage } from './SettingsPage'
import { AdminShoppingPage } from './ShoppingPage'
import { AdminTableRequestsPage } from './TableRequestsPage'
import { AdminTeamPage } from './TeamPage'
import { AdminTestSystemPage } from './TestSystemPage'
import { AdminProgramPage } from './ProgramPage'
import { AdminProjectPage } from './ProjectPage'
import { AdminQrCodesPage } from './QrCodesPage'
import { AdminRolesPage } from './RolesPage'
import { AdminTicketsPage } from './TicketsPage'
import { AdminVotingPage } from './VotingPage'

/**
 * Le back-office.
 *
 * Un sous-routeur plutôt que dix entrées dans `App.tsx` : la porte
 * d'authentification et la coquille s'appliquent alors à tout `/admin/*` sans
 * qu'un écran puisse être ajouté en oubliant l'une ou l'autre.

 */
export function AdminApp() {
  return (
    <AdminGate>
      <AdminLayout>
        <Routes>
          <Route index element={<AdminEventPage />} />
          <Route path="carte" element={<AdminFoodPage />} />
          <Route path="boissons" element={<AdminDrinksPage />} />
          <Route path="billets" element={<AdminTicketsPage />} />
          <Route path="programme" element={<AdminProgramPage />} />
          <Route path="concours" element={<AdminCompetitionPage />} />
          <Route path="votes" element={<AdminVotingPage />} />
          <Route path="contenus" element={<AdminContentPage />} />
          <Route path="commandes" element={<AdminOrdersPage />} />
          <Route path="reservations" element={<AdminReservationsPage />} />
          <Route path="qr-codes" element={<AdminQrCodesPage />} />
          <Route path="projet" element={<AdminProjectPage />} />
          <Route path="finances" element={<AdminFinancePage />} />
          <Route path="courses" element={<AdminShoppingPage />} />
          <Route path="demandes-tables" element={<AdminTableRequestsPage />} />
          <Route path="placement" element={<AdminPlacementPage />} />
          <Route path="cloture" element={<AdminClosingPage />} />
          <Route path="messages" element={<AdminMessagesPage />} />
          <Route path="notifications" element={<AdminNotificationsPage />} />
          <Route path="audience" element={<AdminAudiencePage />} />
          <Route path="avis" element={<AdminFeedbackPage />} />
          <Route path="documentation" element={<AdminDocumentationPage />} />
          <Route path="stocks" element={<AdminStockPage />} />
          <Route path="service" element={<AdminServicePage />} />
          <Route path="objectifs" element={<AdminForecastPage />} />
          <Route path="journal" element={<AdminAuditPage />} />
          <Route path="reglages" element={<AdminSettingsPage />} />
          <Route path="systeme-test" element={<AdminTestSystemPage />} />
          <Route path="equipe" element={<AdminTeamPage />} />
          <Route path="roles" element={<AdminRolesPage />} />
          <Route path="rgpd" element={<AdminGdprPage />} />
          <Route path="compte" element={<AdminAccountPage />} />
        </Routes>
      </AdminLayout>
    </AdminGate>
  )
}
